export const mediumFountainDrink = {
  children: [],
  pickerSelections: '{}',
  lineId: 'none',
  quantity: 1,
  sanityId: '26314208-2489-422d-8071-fb386a84bbd4',
  type: 'Item',
  url: 'do-not-apply',
  name: 'Medium Fountain Drink',
  vendorConfigs: {
    ncr: {
      constantPlu: '80120',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      pluType: 'ignore',
    },
    toast: {
      constantPlu: '900000000609301741/900000000674059483',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      pluType: 'ignore',
    },
  },
};

export const laysClassic = {
  children: [],
  pickerSelections: '{}',
  lineId: 'none',
  quantity: 1,
  sanityId: 'd6692a1d-769a-45d8-add5-1a281c40d929',
  type: 'Item',
  url: 'do-not-apply',
  name: "Lay's Classic",
  vendorConfigs: {
    ncr: {
      parentChildPlu: {
        childPlu: '45220',
        plu: '45110',
      },
      pluType: 'parentChildPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      parentChildPlu: {
        childPlu: '45220',
        plu: '45110',
      },
      pluType: 'parentChildPlu',
      pullUpLevels: null,
    },
    toast: {
      parentChildPlu: {
        childPlu: '900000000526264403/900000000301988512-900000001541216958/900000000307572885',
        plu: '900000000526264403/900000000301988512',
      },
      pluType: 'parentChildPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      parentChildPlu: {
        childPlu: '900000000526264403/900000000301988512-900000001541216958/900000000307572885',
        plu: '900000000526264403/900000000301988512',
      },
      pluType: 'parentChildPlu',
      pullUpLevels: null,
    },
  },
};

export const chocolateChipCookie = {
  children: [],
  pickerSelections: '{}',
  lineId: 'none',
  quantity: 1,
  sanityId: '56f5133d-a6f1-4dba-a56e-e9068e0b75f7',
  type: 'Item',
  url: 'do-not-apply',
  name: 'Chocolate Chip Cookie',
  vendorConfigs: {
    ncr: {
      constantPlu: '40120',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      constantPlu: '40120',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toast: {
      constantPlu: '900000000526264403/900000000301988520',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      constantPlu: '900000000526264403/900000000301988520',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
  },
};

export const brownie = {
  children: [],
  pickerSelections: '{}',
  lineId: 'none',
  quantity: 1,
  sanityId: 'e50ed0b1-49e8-4f81-89cd-2bd0d614cbf3',
  type: 'Item',
  url: 'do-not-apply',
  name: 'Brownie',
  vendorConfigs: {
    ncr: {
      constantPlu: '41110',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      constantPlu: '41110',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toast: {
      constantPlu: '900000000526264403/900000000301988522',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      constantPlu: '900000000526264403/900000000301988522',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
  },
};

export const oatmealCookie = {
  children: [],
  pickerSelections: '{}',
  lineId: 'none',
  quantity: 1,
  sanityId: '045dd252-8f5a-4d21-a1b7-355f7da2d2af',
  type: 'Item',
  url: 'do-not-apply',
  name: 'Oatmeal Cookie',
  vendorConfigs: {
    ncr: {
      constantPlu: '40110',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    ncrDelivery: {
      constantPlu: '40110',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toast: {
      constantPlu: '900000000526264403/900000000921594866',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
    toastDelivery: {
      constantPlu: '900000000526264403/900000000921594866',
      pluType: 'constantPlu',
      pullUpLevels: null,
    },
  },
};

export const nutritionCalorieMapping = {
  [mediumFountainDrink.sanityId]: null,
  [laysClassic.sanityId]: 240,
  [chocolateChipCookie.sanityId]: 310,
  [brownie.sanityId]: 430,
  [oatmealCookie.sanityId]: 290,
};
